/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { dataRemovalRequestReject } from '../../axios/dataRemovalRequestReject'
import type {
	DataRemovalRequestRejectError,
	DataRemovalRequestRejectPathParams,
	DataRemovalRequestRejectRequest,
	DataRemovalRequestRejectResponse,
} from '../../types/DataRemovalRequestReject'

export const dataRemovalRequestRejectMutationKey = () =>
	[{ url: '/organisations/:organisation/data-removal-requests/:dataRemovalRequest/reject' }] as const

export type DataRemovalRequestRejectMutationKey = ReturnType<typeof dataRemovalRequestRejectMutationKey>

export type DataRemovalRequestRejectVariables = {
	organisation: DataRemovalRequestRejectPathParams['organisation']
	dataRemovalRequest: DataRemovalRequestRejectPathParams['dataRemovalRequest']
	data: DataRemovalRequestRejectRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::reject */
export function useDataRemovalRequestReject<TContext = unknown>(
	options?: UseMutationOptions<
		DataRemovalRequestRejectResponse,
		AxiosError<DataRemovalRequestRejectError>,
		DataRemovalRequestRejectVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: dataRemovalRequestRejectMutationKey(),
		mutationFn: ({ organisation, dataRemovalRequest, data }: DataRemovalRequestRejectVariables) =>
			dataRemovalRequestReject(organisation, dataRemovalRequest, data, config).then(res => res.data),
		...options,
	})
}
